import { type FC } from 'react';

import { useStyles } from './useStyles';

interface PayloadEntry {
  name: string;
  value: number;
  color: string;
}

interface ChartTooltipProps {
  active?: boolean;
  payload?: PayloadEntry[];
  label?: string;
  formatValue?: (value: number, name: string) => string;
}

export const ChartTooltip: FC<ChartTooltipProps> = ({ active, payload, label, formatValue }) => {
  const styles = useStyles();

  if (!active || !payload?.length) {
    return null;
  }

  return (
    <div className={styles.root}>
      <div className={styles.label}>{label}</div>
      {payload.map((entry) => (
        <div
          key={entry.name}
          className={styles.entry}
        >
          <span
            className={styles.dot}
            style={{ backgroundColor: entry.color }}
          />
          <span className={styles.name}>{entry.name}:</span>
          <span className={styles.value}>
            {formatValue ? formatValue(entry.value, entry.name) : entry.value}
          </span>
        </div>
      ))}
    </div>
  );
};
